import React, { useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

interface MapProps {
  className?: string;
}

export default function Map({ className = '' }: MapProps) {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: 'AIzaSyDpqH4tlwQL2cgrar7-L6k7ZPVHcPDKFL4',
      version: 'weekly',
    });

    loader.load().then(() => {
      if (mapRef.current) {
        const map = new google.maps.Map(mapRef.current, {
          center: { lat: 49.2827, lng: -123.1207 }, // Vancouver coordinates
          zoom: 12,
          styles: [
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#193341' }]
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [{ color: '#2c5a71' }]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#29768a' }, { lightness: -37 }]
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [{ color: '#406d80' }]
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{ color: '#406d80' }]
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [{ visibility: 'on' }, { color: '#3e606f' }, { weight: 2 }, { gamma: 0.84 }]
            },
            {
              elementType: 'labels.text.fill',
              stylers: [{ color: '#ffffff' }]
            }
          ]
        });

        // Add a marker for Vancouver
        new google.maps.Marker({
          position: { lat: 49.2827, lng: -123.1207 },
          map,
          title: 'TravelHellasPlayGR Vancouver',
          animation: google.maps.Animation.DROP
        });
      }
    });
  }, []);

  return (
    <div 
      ref={mapRef} 
      className={`w-full h-[500px] rounded-lg shadow-xl ${className}`}
    />
  );
}